import type { ComponentType } from 'react';
import { DEFAULT_LUCIDE_ICON_PROPS, type LucideIconName } from './constants';
import type { LucideProps } from 'lucide-react';
import { Menu, Search, X, Mail, ChevronRight, RefreshCw, Clock } from 'lucide-react';

type DynamicLucideIcon = ComponentType<LucideProps>;

type IconMap = {
  [key in LucideIconName]: {
    icon: DynamicLucideIcon;
    props: LucideProps;
  };
};

export const iconMap: IconMap = {
  Menu: {
    icon: Menu,
    props: DEFAULT_LUCIDE_ICON_PROPS,
  },
  Search: {
    icon: Search,
    props: DEFAULT_LUCIDE_ICON_PROPS,
  },
  X: {
    icon: X,
    props: DEFAULT_LUCIDE_ICON_PROPS,
  },
  RefreshCw: {
    icon: RefreshCw,
    props: DEFAULT_LUCIDE_ICON_PROPS,
  },
  Clock: {
    icon: Clock,
    props: DEFAULT_LUCIDE_ICON_PROPS,
  },
  ChevronRight: {
    icon: ChevronRight,
    props: DEFAULT_LUCIDE_ICON_PROPS,
  },
  Mail: {
    icon: Mail,
    props: DEFAULT_LUCIDE_ICON_PROPS,
  },
};

export interface IconProps extends LucideProps {
  icon: LucideIconName;
  className?: string;
}

export const Icon = (props: IconProps) => {
  const { icon, className, size = 24 } = props;

  const Icon = iconMap[icon].icon;
  if (!Icon) return null;

  const iconProps = iconMap[icon].props;

  return (
    <Icon
      style={{ flexShrink: 0 }}
      className={className}
      size={size}
      {...iconProps}
      {...props}
    />
  );
};
